import moment from "moment";
import StatusEnum from "../common/StatusEnum";

export const AccountDataAPI = async (dynamoDBClient, email = "") => {
  const params = {
    TableName: "Users",
    KeyConditionExpression: "Email = :email",
    ExpressionAttributeValues: {
      ":email": email,
    },
    ProjectionExpression:
      "Email , FirstName , LastName, UserId, DateSubmitted,AccountHold",
  };
  try {
    const data = await dynamoDBClient.query(params).promise();
    if (data?.Items?.length !== 0) {
      return data.Items[0];
    } else {
      throw new Error("this is a error");
    }
  } catch (error) {
    throw new Error("this is error");
  }
};

export const getBaseStationDataAPI1 = async (dynamoDBClient, email = "") => {
  try {
    const params = {
      TableName: "GatewayUser",
      ProjectionExpression: "GatewayMAC",
      FilterExpression: "Email = :email",
      ExpressionAttributeValues: {
        ":email": email,
      },
    };

    const data = await dynamoDBClient.scan(params).promise();
    const arr2 = data.Items;
    if (arr2.length === 0) {
      return false;
    }

    const params2 = {
      RequestItems: {
        GatewayData: {
          Keys: [],
          ProjectionExpression: "GatewayMAC, DateUpdated",
        },
      },
    };
    await Promise.all(
      arr2.map(async (element) => {
        params2.RequestItems.GatewayData.Keys.push({
          Email: email,
          GatewayMAC: element.GatewayMAC,
        });
      })
    );

    return params2;
  } catch (error) {
    throw new Error(error);
  }
};

export const getBaseStationDataAPI = async (
  dynamoDBClient,
  email = "",
  params
) => {
  try {
    const baseStationData = [];
    const data = await dynamoDBClient.batchGet(params).promise();

    const arr = data.Responses.GatewayData;
    if (arr.length > 0) {
      const snoozeParams = {
        TableName: "SnoozeSettings",
        FilterExpression: "Email = :email",
        ExpressionAttributeValues: {
          ":email": email,
        },
        ProjectionExpression:
          "SnoozeTimeStampEnd , SnoozeTimeStampStart, GatewayMAC",
      };
      const result = await dynamoDBClient.scan(snoozeParams).promise();
      const snoozeResult = result.Items;
      await Promise.all(
        arr.map(async (element) => {
          if (snoozeResult.length > 0) {
            const data3 = snoozeResult.filter(
              (snoozeItem) => snoozeItem.GatewayMAC === element.GatewayMAC
            );
            if (data3.length > 0) {
              const snooze = data3[0];
              const now = moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSSSSS");
              const isBetween = moment(now).isBetween(
                snooze.SnoozeTimeStampStart,
                snooze.SnoozeTimeStampEnd
              );
              if (isBetween) {
                baseStationData.push({
                  DateUpdated: element.DateUpdated,
                  Status: StatusEnum.snoozed,
                });
              } else {
                baseStationData.push({
                  DateUpdated: element.DateUpdated,
                  Status: StatusEnum.online,
                });
              }
            } else {
              baseStationData.push({
                DateUpdated: element.DateUpdated,
                BeaconStatus: StatusEnum.online,
              });
            }
          } else {
            baseStationData.push({
              DateUpdated: element.DateUpdated,
              Status: StatusEnum.online,
            });
          }
        })
      );
    }

    return baseStationData;
  } catch (error) {
    throw new Error(error);
  }
};

export const getBeaconDataAPI1 = async (dynamoDBClient, email = "") => {
  try {
    const params = {
      TableName: "Beacons",
      ProjectionExpression: "BeaconMAC",
      FilterExpression: "Email = :email",
      ExpressionAttributeValues: {
        ":email": email,
      },
    };

    const data = await dynamoDBClient.scan(params).promise();
    const arr2 = data.Items;
    if (arr2.length === 0) {
      return false;
    }
    const params2 = {
      RequestItems: {
        BeaconData: {
          Keys: [],
          ProjectionExpression: "BeaconMAC, DateUpdated",
        },
      },
    };
    await Promise.all(
      arr2.map(async (element) => {
        params2.RequestItems.BeaconData.Keys.push({
          Email: email,
          BeaconMAC: element.BeaconMAC,
        });
      })
    );

    return params2;
  } catch (error) {
    throw new Error(error);
  }
};

export const getBeaconDataAPI2 = async (dynamoDBClient, email = "", params) => {
  try {
    const beaconData = [];
    const data = await dynamoDBClient.batchGet(params).promise();

    const arr = data.Responses.BeaconData;
    if (arr.length > 0) {
      const snoozeParams = {
        TableName: "SnoozeSettings",
        FilterExpression: "Email = :email",
        ExpressionAttributeValues: {
          ":email": email,
        },
        ProjectionExpression:
          "SnoozeTimeStampEnd , SnoozeTimeStampStart, BeaconMAC",
      };
      const result = await dynamoDBClient.scan(snoozeParams).promise();

      const snoozeResult = result.Items;
      await Promise.all(
        arr.map(async (element) => {
          if (snoozeResult.length > 0) {
            const data3 = snoozeResult.filter(
              (snoozeItem) => snoozeItem.BeaconMAC === element.BeaconMAC
            );
            if (data3.length > 0) {
              const snooze = snoozeResult[0];
              const now = moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSSSSS");
              const isBetween = moment(now).isBetween(
                snooze.SnoozeTimeStampStart,
                snooze.SnoozeTimeStampEnd
              );
              if (isBetween) {
                beaconData.push({
                  DateUpdated: element.DateUpdated,
                  BeaconStatus: StatusEnum.snoozed,
                });
              } else {
                beaconData.push({
                  DateUpdated: element.DateUpdated,
                  BeaconStatus: StatusEnum.online,
                });
              }
            } else {
              beaconData.push({
                DateUpdated: element.DateUpdated,
                BeaconStatus: StatusEnum.online,
              });
            }
          } else {
            beaconData.push({
              DateUpdated: element.DateUpdated,
              BeaconStatus: StatusEnum.online,
            });
          }
        })
      );
    }
    return beaconData;
  } catch (error) {
    throw new Error(error);
  }
};

export const updateAccountAPI = async (dynamoDBClient, email = "") => {
  try {
    var params = {
      TableName: "Users",
      Key: { Email: email, RoleId: "3" },
      UpdateExpression: "SET AccountHold = :newVal",
      ExpressionAttributeValues: {
        ":newVal": false,
      },
      ReturnValues: "ALL_NEW",
    };

    const result = await dynamoDBClient.update(params).promise();
    return result.Attributes;
  } catch (error) {
    throw new Error(error);
  }
};
export const getUserOS = async (dynamoDBClient, email = "") => {
  try {
    const params = {
      TableName: "DeviceToken",
      FilterExpression: "Email = :email",
      ExpressionAttributeValues: {
        ":email": email,
      },
      ProjectionExpression: "MobileDevice, Version, MobileOSVersion",
    };
    const result = await dynamoDBClient.scan(params).promise();

    return result.Items;
  } catch (error) {
    throw new Error(error);
  }
};
export const updateAccountPassword = async (
  dynamoDBClient,
  email = "",
  password = ""
) => {
  try {
    var params = {
      TableName: "Users",
      Key: { Email: email, RoleId: "3" },
      UpdateExpression: "SET Password = :newVal",
      ExpressionAttributeValues: {
        ":newVal": password,
      },
      ReturnValues: "ALL_NEW",
    };

    const result = await dynamoDBClient.update(params).promise();

    return result.Attributes;
  } catch (error) {
    throw new Error(error);
  }
};
